import * as React from "react";
import { detailUrl } from "../../../../store/leaseContracts";

// style, design
import {
  DateCell,
  DurationCell,
  LinkedObject,
  MultiEntryLinks,
  ToolTipCell,
} from "../../../Displays";
import SimpleDateFilter from "../../../Lists/Base/CompleteList/Filters/DateFilter";
import SimpleIntervalFilter from "../../../Lists/Base/CompleteList/Filters/IntervalFilter";
import { detailUrl as tenantDetailUrl } from "../../../../store/tenants";
import { detailUrl as parkingSpotDetailsUrl } from "../../../../store/parkingSpots";
import SimpleTextFilter from "../../../Lists/Base/CompleteList/Filters/TextFilter";
import { StatusLabel } from "../../../Lists/Base/CompleteList/styles";
import StateFilter from "./Filters/StateFilter";

// import InvoiceFilter from "../../LeaseContracts/Filters/InvoiceFilter";

import { sortEndDate } from "../../LeaseContracts/Filters/StateFilter";

export default (hasBillectaViewPermission) => {
  const cols = [
    {
      Header: "Status",
      accessor: "state",
      Cell: ({ row }) => {
        let label = row.original.state_display;
        const state = row.original.state;
        if (
          [6, 7].includes(state) &&
          !row.original.closed_signed &&
          row.original.uses_cancellation_e_signing
        ) {
          label += ` (Ej signerat)`;
        } else if ([6, 7].includes(state) && !row.original.closed_confirmed) {
          label += ` (Ej bekräftat)`;
        }
        const isDraft = row.original.draft;

        if (isDraft) {
          label = "Utkast";
        }

        return <StatusLabel state={state}>{label}</StatusLabel>;
      },
      Filter: StateFilter,
      filter: "textExact",
    },

    {
      Header: "Avtalsnummer",
      accessor: "id_number",
      Cell: ({ value }) => <ToolTipCell text={value} />,
      Filter: SimpleTextFilter,
      filter: "text",
    },

    {
      Header: "Hyresgäst",
      accessor: "tenant.str_representation",
      Cell: ({ row }) => (
        <LinkedObject obj={row.original.tenant} urlMethod={tenantDetailUrl} />
      ),
      Filter: SimpleTextFilter,
      filter: "text",
    },

    {
      Header: "Fastighet",
      accessor: "realestate.str_representation",
      Cell: ({ value }) => <ToolTipCell text={value} />,
      Filter: SimpleTextFilter,
      filter: "text",
    },

    {
      Header: "Fordonsplatser",
      id: "parking_spots",
      Cell: ({ row }) => {
        let mapping = [];
        const parkingSpots = row.original?.parking_spots;

        mapping = parkingSpots.map((a) => {
          return { obj: a, urlMethod: parkingSpotDetailsUrl };
        });

        let restLength;

        if (mapping?.length > 2) {
          restLength = mapping.length - 2;
          mapping = mapping.slice(0, 2);
        }

        return (
          <MultiEntryLinks
            mappings={mapping}
            {...{ restLength: restLength || undefined }}
          />
        );
      },
      disableSortBy: true,
      disableFilters: true,
      disableGlobalFilter: true,
    },

    // searchable
    {
      Header: "Huvudavtal",
      accessor: "main_contract",
      Cell: ({ value }) =>
        value ? (
          <LinkedObject
            obj={{ id: value?.id, str_representation: "Visa" }}
            urlMethod={detailUrl}
          />
        ) : (
          "-"
        ),
      disableSortBy: true,
      disableFilters: true,
      disableGlobalFilter: true,
    },

    // searchable

    {
      Header: "Startdatum",
      accessor: "start_date",
      Cell: ({ value }) => <DateCell date={value} />,
      Filter: SimpleDateFilter,
      filter: "betweenDates",
    },
    // Check this after deploy on staging
    // Potential problems with null values
    {
      Header: "Slutdatum",
      accessor: "closed_date",
      Cell: ({ row }) => (
        <>
          {row.original.closed_date ? (
            <DateCell date={row.original.closed_date} />
          ) : row.original.renewed_to ? (
            <>
              <DateCell date={row.original.renewed_to} />
              <span> (Förlängt)</span>
            </>
          ) : (
            <DateCell date={row.original.end_date} />
          )}
        </>
      ),
      Filter: SimpleDateFilter,
      filter: "betweenDates",
      sortType: sortEndDate,
    },
    {
      Header: "Uppsägningstid",
      accessor: "notify_interval",
      Cell: ({ row }) => (
        <DurationCell
          durationStamp={row.original.notify_interval}
          shadowDate={row.original.notify_time}
        />
      ),
      Filter: SimpleIntervalFilter,
      filter: "text",
    },
    {
      Header: "Förlängningstid",
      accessor: "renew_interval",
      Cell: ({ row }) => {
        const forever = row.original.renew_indefinetely;
        if (forever) {
          return "Tillsvidare";
        }
        return <DurationCell durationStamp={row.original.renew_interval} />;
      },
      Filter: SimpleIntervalFilter,
      filter: "text",
    },
    // searchable
    {
      Header: "Skapat av",
      accessor: "owner.str_representation",
      Cell: ({ value }) => <ToolTipCell text={value} />,
      Filter: SimpleTextFilter,
      filter: "text",
    },
  ];

  // We need backend filter for these kind of filters (true, null, false). Disabled for now.
  if (hasBillectaViewPermission) {
    cols.splice(3, 0, {
      Header: "Aviseringsstatus",
      accessor: "parking_invoicing_active",
      Cell: ({ value, row }) => {
        const billWithLease = row.original.parking_invoicing_bill_with_lease;

        if (billWithLease) {
          return <StatusLabel state={4}>Samaviseras</StatusLabel>;
        }

        return (
          <StatusLabel
            state={
              value === true ? 1 : value === null ? 6 : value === false ? 3 : 10
            }
          >
            {value === true
              ? "Konfigurerad"
              : value === null
              ? "Ej konfigurerad"
              : value === false
              ? "Pausad"
              : "Okänd"}
          </StatusLabel>
        );
      },
      // Filter: InvoiceFilter,
      // filter: "textExact",
      disableSortBy: true,
      disableFilters: true,
      disableGlobalFilter: true,
    });
  }

  return cols;
};
